import { ModalRoute } from '@circlefin/modal-router'
import { SettlementCreditLineProvider } from '@features/settlement-advance/hooks/settlement-credit-line/provider'
import { DepositInstructions } from '@features/settlement-advance/modals'
import { settlementAdvance } from '@services/sections/modal/settlement-advance/settlement-advance'

/**
 * Settlement Advance Router.
 */
export const SettlementAdvanceRouter: React.FC = () => {
  return (
    <SettlementCreditLineProvider>
      <ModalRoute
        content={<DepositInstructions />}
        path={settlementAdvance.depositInstructions}
      />
    </SettlementCreditLineProvider>
  )
}
